import { render, staticRenderFns } from "./fortunellaVenosaDetails.vue?vue&type=template&id=3b34648e&scoped=true&"
import script from "./fortunellaVenosaDetails.vue?vue&type=script&lang=js&"
export * from "./fortunellaVenosaDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b34648e",
  null
  
)

component.options.__file = "fortunellaVenosaDetails.vue"
export default component.exports